import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import TabView, { Tab } from '../../../components/TabView';
import Strings from '../../../Strings';
import WorkTypes from './WorkTypes';
import DevicesConfig from './DevicesConfig';
import DeviceInstructionVideos from '../../Organizations/Configuration/DeviceInstructionVideos';
import { isSuperUser } from '../../../utils/userRoles';
import DefaultMessages from '../../Organizations/Configuration/DefaultMessages';

function FeaturesConfig(props) {
  const { activeTab } = props;
  const tabArray = React.useMemo(() => {
    return [
      <Tab name={Strings.workTypes} path="/admin/config/work-types" key="work-types">
        <WorkTypes />
      </Tab>,
      <Tab name={Strings.defaultReminders} path="/admin/config/default-reminders" key="default-reminders">
        <DefaultMessages />
      </Tab>,
      <Tab name={Strings.devices} path="/admin/config/devices/catalog" key="devices">
        <DevicesConfig {...props}/>
      </Tab>,
      isSuperUser() && (
        <Tab name={Strings.files} path="/admin/config/files" key="files">
          <DeviceInstructionVideos />
        </Tab>
      ),
    ];
  }, []);

  return (
    <TabView key="tabs" activeTab={activeTab} routeMode className="">
      {tabArray}
    </TabView>
  );
}

FeaturesConfig.propTypes = {
  activeTab: PropTypes.any,
};

const mapStateToProps = state => {
  return { role: state.auth.role };
};

const mapDispatchToProps = dispatch => ({ onNavigate: path => dispatch(push(path)) });

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesConfig);